import { UserType } from '@/gql/graphql'
import { useAuthStore } from '@/stores/modules/auth'
import type { RouteMetaMiddleware } from '@/types/shims-vue-router'

export const hasAnyRole = (roles: UserType[]) => {
  const middleware: RouteMetaMiddleware = (params) => {
    const authStore = useAuthStore(params?.store)
    const userRole = authStore.role

    return roles.includes(userRole)
  }

  return middleware
}
